import React from "react";
import { motion } from "framer-motion";

export const Page = ({ number, title, subtitle, right, children }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, ease: "easeOut" }}
    className="max-w-[1600px] mx-auto px-4 md:px-8 py-6 md:py-10"
  >
    <div className="flex items-end justify-between gap-4 pb-6 mb-8 border-b border-[var(--kk-border)]">
      <div>
        {number && (
          <div className="kk-section-num mb-1" data-testid="page-number">
            {number}
          </div>
        )}
        <h1 className="font-display text-3xl md:text-5xl uppercase leading-none" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-2 text-[var(--kk-muted)] text-sm md:text-base max-w-2xl">{subtitle}</p>}
      </div>
      {right && <div className="flex items-center gap-2 flex-shrink-0">{right}</div>}
    </div>
    <div className="kk-fade-in">{children}</div>
  </motion.div>
);

export const EmptyState = ({ title = "Nothing here yet", hint, cta }) => (
  <div className="py-16 text-center border border-dashed border-[var(--kk-border)] bg-[var(--kk-surface)]">
    <div className="font-display text-lg uppercase">{title}</div>
    {hint && <p className="text-[var(--kk-muted)] text-sm mt-2">{hint}</p>}
    {cta && <div className="mt-4 flex justify-center">{cta}</div>}
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="kk-label">{label}</span>
    {children}
  </label>
);

export const StatusPill = ({ status }) => {
  const map = {
    available: "kk-pill-lime",
    sold: "kk-pill-muted",
    reserved: "kk-pill-black",
    open: "kk-pill-lime",
    closed: "kk-pill-muted",
    draft: "kk-pill-muted",
    pending_approval: "kk-pill-black",
    approved: "kk-pill-lime",
    in_progress: "kk-pill-black",
    ready: "kk-pill-lime",
    delivered: "kk-pill-muted",
    paid: "kk-pill-lime",
    sent: "kk-pill-black",
    partial: "kk-pill-black",
    enquiry: "kk-pill-muted",
    test_drive: "kk-pill-black",
    negotiation: "kk-pill-black",
    booked: "kk-pill-lime",
    lost: "kk-pill-muted",
  };
  return (
    <span className={"kk-pill " + (map[status] || "kk-pill-muted")}>
      {(status || "").replace(/_/g, " ")}
    </span>
  );
};
